jQuery(document).ready(function( $ ){


	var cookiebar_activate = {
                message: '<i class="fa fa-exclamation-circle"></i> We use cookies to make your experience on our website better',
                acceptText: '<i class="fa fa-check"></i> Accept',
                declineText: '<i class="fa fa-user-secret"></i> Block cookies',
                policyText: '<i class="fa fa-info-circle"></i> Privacy policy',
								showMoreText:'more', // More options text
								showMoreInfo:'', // More options text
								showMorePrimaryText:'Only Neccesary', // More options text
								showMoreAnalyticsText:'Analytics', // More options text
								showMoreMarketingText:'Marketing', // More options text
                policyURL: '/privacy/#cookie',
                autoEnable: false,
                acceptOnContinue: false,
                acceptOnScroll: false,
                acceptAnyClick: false,
                renewOnVisit: false,
                forceShow: false,
                effect: 'slide',
                zindex: '9000',
                expireDays: 365,
                fixed: true,
								position: 'bottom',
                acceptButton: true,
                declineButton: false,
                policyButton: true,
								showMore:true, // Add more options dropdown
								showMoreMarketing:true, // More options text
								showMoreAnalytics:true, // More options text
								showMoreAnalyticsCheched:true, // Precheck analytics
                acceptFunction: null,
                declineFunction: null,
								acceptFunctionMarketing:null,
								acceptFunctionAnalytics: null
            };

	// COOKIE BAR
	cookiebar_activate = (typeof cookiebar_activate !== 'undefined')? cookiebar_activate : null;
	if(cookiebar_activate) {
		$.cookieBar(cookiebar_activate);
		//ANALYTICS DATA
		if(jQuery.cookieBar('cookies')){
			// RUN On accept
		}
		if(jQuery.cookieBar('analytics')){
			// RUN On accept analytics
		}
		if(jQuery.cookieBar('marketing')){
			// RUN On accept marketing
		}
	}

	// END JQUERY
});
